import React from "react";

import logo from "../img/T.png"

const Logo = () => {

    return (

        <div>
            <img src={logo}/>
        </div>
    )

}

export default Logo;
